import { render, staticRenderFns } from "./InfoHome.vue?vue&type=template&id=6dc5630c&"
import script from "./InfoHome.vue?vue&type=script&lang=js&"
export * from "./InfoHome.vue?vue&type=script&lang=js&"
import style0 from "./InfoHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports